import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import ManagementCommittee from "./ManagementCommittee";
import Founder from "./Founder ";

const History = () => {
  const [activeTab, setActiveTab] = useState("management-committee");
  const underlineRef = useRef(null);
  const navTabsRef = useRef([]);

  // Memoized function to prevent re-creation
  const updateUnderline = useCallback(() => {
    const activeTabElement = navTabsRef.current.find(
      (tab) => tab.dataset.target === activeTab
    );
    if (activeTabElement && underlineRef.current) {
      underlineRef.current.style.width = `${activeTabElement.offsetWidth}px`;
      underlineRef.current.style.left = `${activeTabElement.offsetLeft}px`;
    }
  }, [activeTab]);

  useEffect(() => {
    updateUnderline();
    window.addEventListener("resize", updateUnderline);
    return () => window.removeEventListener("resize", updateUnderline);
  }, [updateUnderline]); // ✅ Dependency added

  useEffect(() => {
    updateUnderline();
    scrollToTop();
  }, [updateUnderline]); // ✅ Dependency added

  const handleTabClick = (tab) => setActiveTab(tab);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const clubDescription = useMemo(
    () => (
      <div className="container mt-5 pt-5 ">
        <div className="row justify-content-center">
          <div className="col-lg-10 ">
            <h3
              style={{
                fontSize: "2.3em",
                textAlign: "center",
                fontFamily: "Dosis, sans-serif",
                color: "rgb(85,47,54)",
                fontWeight: "600",
              }}
            >
              A place where time forgets to rush
            </h3>

            <p
              style={{
                fontSize: "16px",
                fontWeight: "300",
                letterSpacing: "0.5px",
                color: "rgba(0, 0, 0)",
                marginTop: "1.5rem",
                lineHeight: "2em",
                textAlign: "justify",
                fontFamily: "Open Sans, sans-serif",
                padding: "7px",
              }}
            >
              Founded in 1946 by Late Shri RN Day,{" "}
              <span style={{ color: "#DC143C" }}>Jai Club</span> is one of the
              most famous and oldest clubs in Jaipur that is spread across a
              sprawling area of seven acres. This recreational club offers a
              wide array of entertainment options and boasts of the latest
              infrastructure and maintains full-fledged facilities for sports
              like tennis, besides a health club. It has developed into a
              multi-dimensional club offering a multitude of facilities that
              include gym, swimming facility, and sports and yoga club. A cafe
              and restaurant are also available within the premises of{" "}
              <span style={{ color: "#DC143C" }}>Jai Club</span>, which has more
              than 2200 members on roll. It has facilities for recreation /
              sports, dining and lodging. The gymnasium has facilities well
              suited for body fitness. Indoor and outdoor games such as
              badminton, billiards, cards, tennis and cricket can be played.
              There is a children's pool and a swimming pool with adjoining
              dressing rooms.
            </p>
          </div>
        </div>
      </div>
    ),
    []
  );

  return (
    <div>
      {/* Tab Navigation */}
      {clubDescription}

      {/* Tab Content */}
      <div className="container">
        <div className="row">
          <div className="tab-Scroll p-4 mt-4">
            <Founder />
          </div>
        </div>
      </div>
    </div>
  );
};

export default History;
